import { render, staticRenderFns } from "./dropdown-multiselect-v2.vue?vue&type=template&id=73f0e48c&scoped=true&"
import script from "./dropdown-multiselect-v2.vue?vue&type=script&lang=js&"
export * from "./dropdown-multiselect-v2.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-multiselect-v2.vue?vue&type=style&index=0&id=73f0e48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f0e48c",
  null
  
)

export default component.exports